import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './styleChartPie.css'
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';

function ELEMENT_KPI_FTE_TREE(props) {
  //Helpers
  const { t } = useTranslation();

  const { 
    inputParam_HideHeader = false,
    inputParam_ComponentContent = null,
    inputParam_UseFake = false,
    inputParam_BoardStructure = null,
    inputParam_Container = null
  } = props;

  const initialData = {
    name: t('data-lang-lbl-endowment'),
    children: inputParam_ComponentContent?.items
  }

  const fakeData = {
    name: "Categorias",
    children: [
      {
          name: "Categoria 1",
          value: 25,
          children: [
              { name: "Item 1.1", value: 10 },
              { name: "Item 1.2", value: 15 }
          ]
      },{
        name: "Categoria 2",
        value: 25,
        children: [
            { name: "Item 2.1", value: 6 },
            { name: "Item 2.2", value: 4 },
            { name: "Item 2.3", value: 8 }
        ]
      }
    ]
  };

  const [viewStack, setViewStack] = useState([!inputParam_UseFake ? initialData : fakeData]);

  const handleDataPointClick = (event, chartContext, config) => {
      const clickedData = config.w.config.series[config.seriesIndex].data[config.dataPointIndex];
      if (clickedData && clickedData.children) {
          setViewStack([...viewStack, clickedData]);
      }
  };

  const handleDrillup = () => {
      if (viewStack.length > 1) {
          const newStack = [...viewStack];
          newStack.pop();
          setViewStack(newStack);
      }
  };

  const currentView = viewStack[viewStack.length - 1];

  const series = [{
      name: currentView.name,
      data: currentView.children.map(child => ({
          x: child.code ? `${child.code}: ${child.name}` : child.name,
          y: child.value || 1,
          children: child.children
      }))
  }];

  const generateOptions = (isInCategory) => ({
    chart: {
      height: "100%",
      type: 'treemap',
      events: {
          dataPointSelection: handleDataPointClick
      },
      toolbar: {
        tools: {
          customIcons: isInCategory ? [{
            //icon: `<i class="ms-Icon ms-Icon--Back" aria-hidden="true"></i>`,
            icon: `<div class="d-flex"><i class="ms-Icon ms-Icon--Back" aria-hidden="true"></i>&nbsp;<div>Regresar</div></div>`,
            index: -1,
            title: 'Regresar',
            class: 'custom-legeng-chart',
            click: function(chart, opts, e) {
              handleDrillup();
            }
          }] : []
        }
      }
    },
    legend: {
      show: false
    }
  });

  const renderComponent = () => {
    return  <Row className='h-100' style={{opacity: inputParam_UseFake ? ".4" : ""}}>
              <Col id="chartTreeMap" xl={12} className="h-95">
                <ReactApexChart
                  options={generateOptions(viewStack.length > 1)}
                  series={series}
                  type="treemap" height="100%" />
              </Col>
            </Row>
  }

  return (
    <>
      {
        !inputParam_UseFake &&
        <Card className='h-100'>
          {
            !inputParam_HideHeader &&
            <Card.Header className="card-header-compact">
              <Card.Title className="justify-content-between">
                <b>{t('data-lang-lbl-endowment')}</b>{ viewStack.length > 1 ? `: ${viewStack[1].x}` : '' }
                <div className='toolbar d-flex'>
                  <HEADER_TOOLBAR
                    inputParam_BoardStructure={inputParam_BoardStructure}
                    inputParam_Container={inputParam_Container}
                  />
                </div>
              </Card.Title>
            </Card.Header>
          }
          <Card.Body className='h-100 pb-0 pe-1'>
            {renderComponent()}
          </Card.Body>
        </Card>
      }
      {inputParam_UseFake && renderComponent()}
    </>
    
  );
}

export default ELEMENT_KPI_FTE_TREE;